<template>
	<section class="hero py-5 bg-secondary">
		<div class="container">
			<div class="row align-items-center text-center text-md-left">
				<div class="col-md-5 mb-5 mb-md-0">
					<h1 class="display-3 mb-4">
						The Easiest way to order an appraisal online
					</h1>
					<div class="auth">
						<button class="btn btn-primary mr-3 rounded">Sign Up</button>
						<button class="btn btn-accent rounded">Login</button>
					</div>
				</div>
				<div class="col-md-6 offset-md-1 text-center">
					<img width="400px" src="https://hviorder.ca/img/imac-flat.png" class="">
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'Hero',
		data () {
			return {}
		}
	}
</script>
